﻿import './tracker.config';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basics/tk.manager';
import TKNavigationSidebar from '@tk/components/tk.navigation.sidebar';
import TKHeader from '@tk/components/tk.header';
import TKViewport from '@tk/basics/tk.viewport';
import TKBasketButton from '@/components/tk.basket.button';
import TKContextMenu from '@/components/kdmz.context.menu';
import TKFlag from '@tk/components/tk.flag';
import TKProductTile from '@tk/components/tk.product.tile';
import TKProductVariants from '@tk/components/tk.product.variants';
import TKTooltip from '@tk/components/tk.tooltip';
import TKFilter from '@tk/components/tk.filter';
import TKFilterChip from '@tk/components/tk.filter.chip';
import TKFilterResult from '@tk/components/tk.filter.result';
import TKFilterDropdown from '@tk/components/tk.filter.dropdown';
import TKFilterGroupWrapper from '@tk/components/tk.filter.group.wrapper';
import TKFilterGroup from '@tk/components/tk.filter.group';
import TKFilterSearch from '@tk/components/tk.filter.search';
import TKFilterSelectReset from '@tk/components/tk.filter.select.reset';
import TKFilterDrilldownButton from '@tk/components/tk.filter.drilldown.button';
import TKArticleList from '@tk/components/tk.article.list';
import TKPrice from '@tk/components/tk.price';
import TKStock from '@tk/components/tk.stock';
import TKFavoriteButton from '@tk/components/tk.favorite.button';
import TKFormValidator from '@/controls/kdmz.form.validator';
import TKCompareListLink from '@tk/components/tk.compare.list.link';
import TKCompareButton from '@tk/components/tk.compare.button';
import TKCarousel from '@/components/kdmz.carousel';
import TKArticleListSort from '@tk/components/tk.article.list.sort';
import TKArticleListLayoutSwitch from '@tk/components/tk.article.list.layout.switch';
import TKBreadcrumb from '@tk/components/tk.breadcrumb';
import TKTable from '@tk/components/tk.table';
import TKQuickOrder from '@/components/kdmz.quick.order';
import KDMZFreitext from '@/components/kdmz.freitext';
import TKTabsTab from '@/components/kdmz.tabs.tab';
import TKButtonDropdown from '@/controls/kdmz.button.dropdown';
import TKHeaderSearch from '@/components/tk.header.search';
import KDMZMinibasket from '@/components/kdmz.minibasket';
import KDMZSearch from '@/components/kdmz.search';
import TKFavoriteInfo from '@/components/tk.favorite.info';
import TKTabsAccordion from '@/components/kdmz.tabs.accordion';
import TKTracker from '@tk/components/tracker/tk.tracker';
// import TKFormTracker from '@tk/components/tk.form.tracker';
import TKTracking from '@tk/components/tracker/tk.tracking';
import TKFormDatepicker from '@tk/controls/tk.form.datepicker';

// Custom KDMZ elements
import KDMZFormElement from '@/components/kdmz.form.element';
import KDMZSelectBox from '@/components/kdmz.select.box';
import KDMZDialog from '@/components/kdmz.dialog';
import KDMZBasketButton from '@/components/kdmz.basket.button';
import KDMZProductTile from '@/components/kdmz.product.tile';
import KDMZVisibilityController from '@/components/kdmz.class.visibility.controller';

import 'flatpickr/dist/flatpickr.min.css';
import 'tippy.js/dist/tippy.css';
import '@splidejs/splide/dist/css/splide.min.css';
import '@scss/modules/general.scss';
import '@scss/modules/article.scss';
import '@scss/modules/struct.scss';
import '@scss/modules/cv-ces.scss';
import '@iconfont/iconfont/material-icons.css';

export default class Struct extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-viewport', constructor: TKViewport },
            { name: 'tk-tracker', constructor: TKTracker },
            { name: 'tk-tracking', constructor: TKTracking },
            { name: 'tk-button-dropdown', constructor: TKButtonDropdown },
            { name: 'tk-header', constructor: TKHeader },
            { name: 'tk-nav-sidebar', constructor: TKNavigationSidebar },
            { name: 'tk-basket-button', constructor: TKBasketButton },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-flag', constructor: TKFlag },
            { name: 'tk-product-tile', constructor: TKProductTile },
            { name: 'tk-product-variants', constructor: TKProductVariants },
            { name: 'tk-tooltip', constructor: TKTooltip },
            { name: 'tk-filter', constructor: TKFilter },
            { name: 'tk-filter-chip', constructor: TKFilterChip },
            { name: 'tk-filter-result', constructor: TKFilterResult },
            { name: 'tk-filter-dropdown', constructor: TKFilterDropdown },
            { name: 'tk-filter-group-wrapper', constructor: TKFilterGroupWrapper },
            { name: 'tk-filter-group', constructor: TKFilterGroup },
            { name: 'tk-filter-search', constructor: TKFilterSearch },
            { name: 'tk-filter-select-reset', constructor: TKFilterSelectReset },
            { name: 'tk-filter-drilldown-button', constructor: TKFilterDrilldownButton },
            { name: 'tk-article-list', constructor: TKArticleList },
            { name: 'tk-price', constructor: TKPrice },
            { name: 'tk-stock', constructor: TKStock },
            { name: 'tk-tabs-tab', constructor: TKTabsTab },
            { name: 'tk-favorite-button', constructor: TKFavoriteButton },
            { name: 'tk-favorite-info', constructor: TKFavoriteInfo },
            { name: 'tk-form-element', constructor: KDMZFormElement },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-compare-list-link', constructor: TKCompareListLink },
            { name: 'tk-compare-button', constructor: TKCompareButton },
            { name: 'tk-carousel', constructor: TKCarousel },
            { name: 'tk-article-list-sort', constructor: TKArticleListSort },
            { name: 'tk-article-list-layout-switch', constructor: TKArticleListLayoutSwitch },
            { name: 'tk-header-search', constructor: TKHeaderSearch },
            { name: 'tk-breadcrumb', constructor: TKBreadcrumb },
            { name: 'kdmz-select-box', constructor: KDMZSelectBox },
            { name: 'tk-dialog', constructor: KDMZDialog },
            { name: 'tk-minibasket', constructor: KDMZMinibasket },
            { name: 'kdmz-search', constructor: KDMZSearch },
            { name: 'tk-table', constructor: TKTable },
            { name: 'tk-quick-order', constructor: TKQuickOrder },
            { name: 'kdmz-basket-button', constructor: KDMZBasketButton },
            { name: 'kdmz-freitext', constructor: KDMZFreitext },
            { name: 'kdmz-product-tile', constructor: KDMZProductTile },
            { name: 'kdmz-visibility-controller', constructor: KDMZVisibilityController },
            { name: 'tk-form-datepicker', constructor: TKFormDatepicker },
        ]);
    }
}

new Struct();
